import axios from 'axios'

const {
  VUE_APP_API_SERVER,
  VUE_APP_RECRUITMENT_API,
  VUE_APP_POSTCODE,
  VUE_APP_PRINTIT,
} = process.env

// Register user
const registerUser = async (data) => {
  try {
    return await axios.post(
      `${VUE_APP_RECRUITMENT_API}/applicant?site=${
        window.siteVar.referer === 'UK' ? 'uk' : 'ie'
      }`,
      data
    )
  } catch (err) {
    return null
  }
}

// Reset password
const resetPassword = async (data) => {
  try {
    return await axios.post(
      `${VUE_APP_RECRUITMENT_API}/applicant/password-reset?site=${
        window.siteVar.referer === 'UK' ? 'uk' : 'ie'
      }`,
      data
    )
  } catch {
    return null
  }
}

// Check token to see if we are able to confirm the user
const checkCanConfirm = async (token) => {
  try {
    return await axios.get(
      `${VUE_APP_RECRUITMENT_API}/applicant/check-can-confirm?site=${
        window.siteVar.referer === 'UK' ? 'uk' : 'ie'
      }`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return err
  }
}

// Confirm registration
const confirmRegistration = async (token, data) => {
  try {
    return await axios.put(
      `${VUE_APP_RECRUITMENT_API}/applicant/confirm?site=${
        window.siteVar.referer === 'UK' ? 'uk' : 'ie'
      }`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

// Confirm registration
const confirmPhoneRegistration = async (token, code) => {
  try {
    return await axios.post(
      `${VUE_APP_RECRUITMENT_API}/applicant/confirm/enter-phone-message?site=${
        window.siteVar.referer === 'UK' ? 'uk' : 'ie'
      }`,
      { code },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

// Login
const loginUser = async (data) => {
  try {
    return await axios.post(
      `${VUE_APP_RECRUITMENT_API}/applicant/login?site=${
        window.siteVar.referer === 'UK' ? 'uk' : 'ie'
      }`,
      data
    )
  } catch (err) {
    return null
  }
}

// Update Registration Login
const updateRegistrationLogin = async (data) => {
  try {
    return await axios.post(
      `${VUE_APP_RECRUITMENT_API}/applicant/registration-update-login?site=${
        window.siteVar.referer === 'UK' ? 'uk' : 'ie'
      }`,
      data
    )
  } catch (err) {
    return null
  }
}

// Check Registration OTP
const updateRegistrationOTPCheck = async (token, data) => {
  try {
    return await axios.post(
      `${VUE_APP_RECRUITMENT_API}/applicant/check-registration-otp?site=${
        window.siteVar.referer === 'UK' ? 'uk' : 'ie'
      }`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

// Check Registration OTP
const registrationDetailsUpdate = async (token, data) => {
  try {
    return await axios.patch(
      `${VUE_APP_RECRUITMENT_API}/applicant/registration-details-update?site=${
        window.siteVar.referer === 'UK' ? 'uk' : 'ie'
      }`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

// Login
const getUserdata = async (token) => {
  try {
    return await axios.get(
      `${VUE_APP_RECRUITMENT_API}/applicant?site=${
        window.siteVar.referer === 'UK' ? 'uk' : 'ie'
      }`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

// Save application
const saveApplication = async (token, data) => {
  try {
    return await axios.put(
      `${VUE_APP_RECRUITMENT_API}/applicant/application?site=${
        window.siteVar.referer === 'UK' ? 'uk' : 'ie'
      }`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

const saveEthnicity = async (token, data) => {
  try {
    return await axios.put(
      `${VUE_APP_RECRUITMENT_API}/applicant/ethnicity`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

// UK postcode lookup - Eircode lookup is a seperate vue component
const postCodeLookup = async (postcode) => {
  try {
    return await axios.get(
      `${VUE_APP_API_SERVER}${VUE_APP_POSTCODE}/${postcode}`
    )
  } catch (err) {
    return null
  }
}

// Get all travel centers
const getTravelCenters = async () => {
  const tcResults = []
  try {
    const res = await axios.get(`${VUE_APP_RECRUITMENT_API}/admin/centres`)
    if (res && res.data && res.data.success) {
      for (const value of res.data.centres) {
        if (value.title) {
          tcResults.push(value)
        }
      }
      return tcResults
    }
  } catch (err) {
    return null
  }
}

// Validate user
const validateUser = async (token) => {
  try {
    return await axios.get(
      `${VUE_APP_RECRUITMENT_API}/applicant?site=${
        window.siteVar.referer === 'UK' ? 'uk' : 'ie'
      }`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

// Get interview slots months
const getInterviewSlotsMonths = async (data) => {
  try {
    return await axios.get(
      `${VUE_APP_RECRUITMENT_API}/applicant/interviews/slots/month?month=${data.month}&year=${data.year}`
    )
  } catch (err) {
    return null
  }
}

// Get interview slots days
const getInterviewSlotsDay = async (data) => {
  try {
    return await axios.get(
      `${VUE_APP_RECRUITMENT_API}/applicant/interviews/slots/day?day=${data.day}&month=${data.month}&year=${data.year}`
    )
  } catch (err) {
    return null
  }
}

// Book slot
const bookSlot = async (token, id) => {
  try {
    return await axios.put(
      `${VUE_APP_RECRUITMENT_API}/applicant/interviews/slots/${id}`,
      null,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

// Check booking slots
const checkBookingSlots = async (token) => {
  try {
    return await axios.get(
      `${VUE_APP_RECRUITMENT_API}/applicant/interviews/slots/booked`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

// Save onboarding forms
const saveOnboardingForms = async (token, data) => {
  try {
    return await axios.put(
      `${VUE_APP_RECRUITMENT_API}/applicant/onboarding/forms?site=${
        window.siteVar.referer === 'UK' ? 'uk' : 'ie'
      }`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

// Get PDF
const getPDF = async (data) => {
  return axios.post(
    `${VUE_APP_PRINTIT}/api/recruitment?site=${
      window.siteVar.referer === 'UK' ? 'uk' : 'ie'
    }`,
    data,
    {
      responseType: 'blob',
    }
  )
}

// Get Content Managed Copy
const fetchManagedContent = async (token, id) => {
  try {
    return await axios.get(
      `${VUE_APP_RECRUITMENT_API}/applicant/content-manager/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

const uploadEnglishCertificate = async (token, data) => {
  try {
    return await axios.post(
      `${VUE_APP_RECRUITMENT_API}/applicant/english-certificate-upload`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

const uploadMathsCertificate = async (token, data) => {
  try {
    return await axios.post(
      `${VUE_APP_RECRUITMENT_API}/applicant/maths-certificate-upload`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

const getCertificateNames = async (token, applicantId) => {
  try {
    return await axios.get(
      `${VUE_APP_RECRUITMENT_API}/applicant/files/certificate-names/${applicantId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

const updateAddress = async (token, data) => {
  try {
    return await axios.patch(
      `${VUE_APP_RECRUITMENT_API}/applicant/update-address`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    return null
  }
}

const getReferenceDetails = async (id) => {
  try {
    return await axios.get(
      `${VUE_APP_RECRUITMENT_API}/references/get-reference-details/${id}`
    )
  } catch (err) {
    return null
  }
}

const submitReference = async (id, data) => {
  try {
    return await axios.patch(
      `${VUE_APP_RECRUITMENT_API}/references/submit-reference/${id}`,
      data
    )
  } catch (err) {
    return null
  }
}

export {
  registerUser,
  resetPassword,
  loginUser,
  checkCanConfirm,
  confirmRegistration,
  confirmPhoneRegistration,
  updateRegistrationLogin,
  updateRegistrationOTPCheck,
  registrationDetailsUpdate,
  saveApplication,
  saveEthnicity,
  postCodeLookup,
  getTravelCenters,
  getInterviewSlotsMonths,
  getInterviewSlotsDay,
  bookSlot,
  validateUser,
  checkBookingSlots,
  saveOnboardingForms,
  getUserdata,
  getPDF,
  fetchManagedContent,
  uploadEnglishCertificate,
  uploadMathsCertificate,
  getCertificateNames,
  updateAddress,
  getReferenceDetails,
  submitReference,
}
